import React from 'react';

import { useResources } from 'lib/hooks/queries/resoruces/useResources';

import AgTablePage from 'components/shared/AgTablePage/AgTablePage';

import NewResourceModal from './components/NewResourceModal';
import { defaultFilters } from './lib';
import { defaultColumns } from './lib/resourceTableCols';

export default function Superbills() {
  const columnDefs = defaultColumns();

  return (
    <AgTablePage
      ModalComponent={NewResourceModal}
      defaultColumns={columnDefs}
      defaultFilters={defaultFilters}
      useData={useResources}
      name="resources"
    />
  );
}
